module.exports = __webpack_public_path__ + "img/user_input_icon.865cba9f.svg";